import { Preferences } from '@capacitor/preferences';
import { Capacitor } from '@capacitor/core';


export default async function auth({ next, router }) {
  let userToken = await Preferences.get({ key: '_userToken' })
  let sensor = await Preferences.get({ key: '_sensor' })

  if (!JSON.parse(userToken.value)) {
    return router.push('/');
  }

  if (!Capacitor.isNativePlatform()) {
    await Preferences.set({
      key: "_sensor",
      value: JSON.stringify({
        pass: true,
      })
    });
    return next();
  }

  if (JSON.parse(sensor.value) && !JSON.parse(sensor.value).pass) {
    return router.push('/fingerprint');
  }

  return next();
}
